import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.contractInformation.loading;
export const selectErrorMessage = (state: RootState) =>
  state.contractInformation.error;
export const contractInformationDataResponse = (state: RootState) =>
  state.contractInformation.contractInformationResponse;
